export default "__VITE_ASSET__DSdWcZCJ__"